module.exports = __webpack_public_path__ + "static/Amazon Mini TV-67e2b430521a6de10815a448e3b4d6dc.png";